export default __webpack_public_path__ + "static/media/Bionic-Arm-03.40b06302.jpg";